import {
  faBullhorn as faBullhornDt,
  faFolder as faFolderDt,
  faLaptopMedical as faLaptopMedicalDt,
  faNewspaper as faNewsPaperDt,
} from "@fortawesome/pro-duotone-svg-icons";
import {
  faBullhorn,
  faChevronRight,
  faFolder,
  faLaptopMedical,
  faNewspaper,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ComunicadosBenef } from "../../interfaces/entities/ComunicadosBenef";
import { NotificationEnum } from "../../interfaces/enum/NotificationEnum";
import { TypeNotificationEnum } from "../../interfaces/enum/TypeNotificationEnum";
import { NotificationCardProps } from "../../interfaces/props/NotificationCardProps";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import { descriptionRegex } from "../../utils/DescriptionRegex";
import { OpenPageType } from "../../interfaces/enum/SelectedTypeEnum";

import "./styles.css";
import useAccessibleKeyPress from "../../utils/hooks/useAccessibleKeyPress";

function NotificationCard(props: NotificationCardProps) {
  const [notification, setNotification] = useState<ComunicadosBenef>();
  const [read, setRead] = useState<boolean>(false);
  const navigate = useNavigate();
  const accessibility = useAccessibility();

  useEffect(() => {
    const response = descriptionRegex(props.comunicadosBenef.descr);
    let result = props.comunicadosBenef;
    result.descr = response;
    setNotification(result);

    if (props.comunicadosBenef.indLido === "S") {
      setRead(true);
    }
  }, [props]);

  const getIcon = () => {
    switch (props.comunicadosBenef.tipoNotificacao) {
      case NotificationEnum.Mensagem:
        return read ? faBullhorn : faBullhornDt;
      case NotificationEnum.PesquisaSatisfacao:
        return read ? faNewspaper : faNewsPaperDt;
      case NotificationEnum.SaudeOnline:
      case NotificationEnum.Notificacao:
        return read ? faLaptopMedical : faLaptopMedicalDt;
      default:
        return read ? faFolder : faFolderDt;
    }
  };

  const handleConfirmarConsulta = () => {
    const { idAgenda, tipo } = props.comunicadosBenef.openComunic.abrirConfirmAgendamentoFuturo;
    navigate(`/notificacoes/saude_online/${idAgenda}/${tipo}/${props.comunicadosBenef.idComunic}`)
  }

  const handleMedicinaPreventiva = () => {
    const { idEventoUsr } = props.comunicadosBenef.openComunic.abrirGestaoConviteEventoPage;
    navigate(`/notificacoes/saude_online/medicina_preventiva/${props.comunicadosBenef.idComunic}/${idEventoUsr}?lido=${props.comunicadosBenef.indLido}`)
  }

  const viewNotification = () => {
    if (props.comunicadosBenef.tipoComunic.indAbrirPesquisaSatisfacao === 'S') {
      return navigate(`/notificacoes/pesquisaDeSatifacao/${props.comunicadosBenef.idComunic}/${props.comunicadosBenef.openComunic.abrirPesqSatisfacao.idQuestOperador}`);
    }
    if (props.comunicadosBenef.openComunic?.abrirPagina
      ?.paginaRedirecionamento === OpenPageType.CronicosGestaoAltaPage) {
      return navigate(`/saudeBemEstar/gestaoDeCronicos/encerramento/${props.comunicadosBenef.idComunic}`);
    }
    if (
      props.comunicadosBenef.openComunic?.abrirPagina
        ?.paginaRedirecionamento === OpenPageType.CronicosSelecaoIndexPage
    ) {
      navigate(
        `/saudeBemEstar/gestaoDeCronicos/captacao/inicio/${props.comunicadosBenef.idComunic}`
      );
      return;
    }
    if (props.comunicadosBenef.openComunic?.abrirPagina?.paginaRedirecionamento === OpenPageType.CronicosAdesaoTermoPage) {
      return navigate(`/saudeBemEstar/gestaoDeCronicos/primeiroAgendamento/${props.comunicadosBenef.idComunic}`);
    }
    if (props.comunicadosBenef.openComunic.tipoSelecionado === 'abrirConfirmAgendamentoFuturo') {
      handleConfirmarConsulta()
      return
    }
    if (props.comunicadosBenef.openComunic.tipoSelecionado === 'AbrirGestaoConviteEventoPage') {
      handleMedicinaPreventiva()
      return
    }

    switch (props.comunicadosBenef.tipoComunic.codigo) {
      case TypeNotificationEnum.Comunicados:
        navigate(`/notificacoes/mensagem/${props.comunicadosBenef.idComunic}`);
        break;
      case TypeNotificationEnum.Notificacoes:
        if (props.selectedTab === TypeNotificationEnum.Notificacoes) {
          navigate(
            `/notificacoes/${TypeNotificationEnum.Notificacoes}/${props.comunicadosBenef.idComunic}`
          );
        } else {
          navigate(
            `/notificacoes/${TypeNotificationEnum.SaudeOnline}/${props.comunicadosBenef.idComunic}`
          );
        }
        break;
      case TypeNotificationEnum.PesquisaSatisfacao:
        navigate(
          `/notificacoes/pesquisaDeSatifacao/${props.comunicadosBenef.idComunic}/${props.comunicadosBenef.openComunic.abrirPesqSatisfacao.idQuestOperador}`
        );
        break;
      case TypeNotificationEnum.SaudeOnline:
        props.comunicadosBenef.openComunic.abrirDetalhes !== null &&
          navigate(
            `/notificacoes/${TypeNotificationEnum.SaudeOnline}/${props.comunicadosBenef.idComunic}`
          );
        break;
    }
  };

  const handleKeyPress = useAccessibleKeyPress(viewNotification);

  const boxStyle = (read: boolean) => ({
    ...accessibility.contrastStyle,
    ...accessibility.contrastBorderAccessibility,
    borderLeft:
      accessibility.contrastMode && !read
        ? "6px solid #FFFF00"
        : "1px solid white",
  });

  return (
    <div
      style={boxStyle(read)}
      className={`notification-card ${!read && "read-notification-card"}`}
      onClick={viewNotification}
      onKeyDown={handleKeyPress}
      tabIndex={0}
    >
      <div className="notification-info">
        <div
          className={`notification-icon-holder ${!read && "read-notification-icon"
            } ${accessibility.contrastMode && "accessibility-color"}`}
        >
          <FontAwesomeIcon icon={getIcon()} size="2xl" />
        </div>
        <div className="notification-info-holder">
          <div className="notification-info-texts">
            <h1
              className={"notifications-description"}
              style={accessibility.textStyleAccessibility}
            >
              {new Date(props.comunicadosBenef.dtIncl).toLocaleDateString(
                "pt-BR"
              )}{" "}
              -{" "}
              {new Date(props.comunicadosBenef.dtIncl)
                .getHours()
                .toString()
                .padStart(2, "0")}
              :
              {new Date(props.comunicadosBenef.dtIncl)
                .getMinutes()
                .toString()
                .padStart(2, "0")}
            </h1>
            <h1
              className={
                read ? "notification-title-readed" : "notification-title"
              }
              style={accessibility.textStyleAccessibility}
            >
              {props.comunicadosBenef.titulo}
            </h1>
          </div>
          <button
            style={accessibility.textStyleAccessibility}
            className="view-notification"
            onClick={viewNotification}
          >
            Ver notificação
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotificationCard;
